"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util;
(function (util) {
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = function (items) {
        var obj = {};
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            obj[item] = item;
        }
        return obj;
    };
})(util = exports.util || (exports.util = {}));
//# sourceMappingURL=util.js.map